<template>
  <div class="card">
    <BlockInterface v-if="loading" />
    <h3 class="card-title">Cargar liquidación</h3>
    <div class="third-center" v-if="personas && !loading && !guardando && !validando">
      <file-select v-model="file"></file-select>
    </div>
    <div v-if="liquidaciones.length > 0">
      <section
        v-if="alertasImportacion.length"
        class="alertas-importacion"
        aria-labelledby="titulo-alertas-importacion"
      >
        <h4 id="titulo-alertas-importacion">Controles de importación</h4>
        <p>
          Se encontraron {{ alertasImportacion.length }} observaciones en la liquidación y sus recibos.
          Se usará la fecha de ingreso del Excel y el sueldo básico de la categoría del legajo.
          Los legajos no se modificarán.
        </p>
        <p v-if="erroresImportacion.length" class="errores-importacion" role="alert">
          Hay {{ erroresImportacion.length }} error(es) que deben corregirse antes de guardar.
        </p>
        <div class="alertas-tabla">
          <table>
            <caption>Diferencias y datos faltantes por recibo</caption>
            <thead>
              <tr>
                <th scope="col">Liquidación / período</th>
                <th scope="col">Legajo</th>
                <th scope="col">Empleado</th>
                <th scope="col">Dato a revisar</th>
                <th scope="col">Nivel</th>
                <th scope="col">Sistema / cálculo</th>
                <th scope="col">Excel de Holistor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(alerta, index) in alertasImportacion" :key="index">
                <td>#{{ alerta.numero_liquidacion }} / {{ alerta.periodo }}</td>
                <td>{{ alerta.numero_legajo }}</td>
                <td>{{ alerta.nombre }}</td>
                <td>
                  {{ nombreCampoAlerta(alerta.campo) }}
                  <small v-if="alerta.mensaje" class="detalle-alerta">{{ alerta.mensaje }}</small>
                </td>
                <td :class="{ 'errores-importacion': alerta.nivel === 'error' }">
                  {{ alerta.nivel === 'error' ? 'Corregir' : 'Revisar' }}
                </td>
                <td>{{ valorAlerta(alerta, 'sistema') }}</td>
                <td>{{ valorAlerta(alerta, 'excel') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <h4 class="card-title">Vista previa</h4>
      <div v-for="liquidacion in liquidaciones" :key="liquidacion.numero">
        <div class="cols2">
          <pd-input
            class="my-0"
            readonly
            classInput="form-control readonly text-bold text-success"
            v-model="liquidacion.periodo"
            label="Período"
            id="periodo"
            placeholder="periodo"
          ></pd-input>
          <pd-input
            class="my-0"
            readonly
            classInput="form-control readonly text-bold text-success"
            v-model="liquidacion.tipo"
            label="Tipo"
            id="Tipo"
            placeholder="Tipo"
          ></pd-input>
          <pd-input
            class="my-0"
            readonly
            classInput="form-control readonly text-bold text-secondary"
            :value="recibos_liquidacion(liquidacion)"
            label="Recibos liquidados"
            id="Recibosliquidados"
            placeholder="Recibos liquidados"
          ></pd-input>
          <pd-input
            class="my-0"
            readonly
            classInput="form-control readonly text-bold text-secondary"
            :value="neto_liquidacion(liquidacion)"
            label="Neto total"
            id="Netototal"
            placeholder="Neto total"
          ></pd-input>
        </div>
        <table-list
          ref="tablelist"
          :showFilter="true"
          :data="liquidacion.recibos"
          :header="headers"
          :body="body"
          @rowClicked="previewRecibo"
        ></table-list>
        <ShowRecibos
          v-if="reciboSelected"
          :recibo="reciboSelected"
          @close="close"
          :readonly="true"
          :preview="true"
        ></ShowRecibos>
      </div>
      <div class="d-flex right mt-1">
        <button class="btn btn-primary" :disabled="loading || guardando || validando || !validacionRemotaCompleta || erroresImportacion.length > 0" @click="save">
          Guardar liquidacion
        </button>
      </div>
      <p v-if="validando" role="status">Comprobando la liquidación con los datos del sistema…</p>
    </div>
    <div class="my-3" v-else-if="failed">
      <h3 class="card-title text-center">No se ha podido cargar el archivo</h3>
    </div>
  </div>
</template>
<script>
import XLSX from "xlsx";
import { LiquidacionesServices } from "../services/LiquidacionesServices";
import { revisarLiquidaciones } from "../services/LiquidacionAlertas";
import TableList from "@/components/elements/TableList";
import FileSelect from "@/components/elements/FileSelect";
import { PersonasService } from "@/modules/personas/services/PersonasServices";
import ShowRecibos from "@/modules/recibos/views/ShowRecibos";
import Swal from "sweetalert2";
import BlockInterface from "@/components/elements/BlockInterface";
export default {
  name: "NuevaLiquidacion",
  components: {
    BlockInterface,
    FileSelect,
    TableList,
    ShowRecibos,
  },
  data() {
    return {
      failed: false,
      file: null,
      filas: [],
      liquidaciones: [],
      headers: [
        { value: "Persona", sortable: true },
        { value: "Legajo", sortable: true },
        { value: "Neto", sortable: true },
      ],
      body: [
        {
          class: "important",
          data: [
            { value: "nombre", class: "text-primary" },
            {
              value: "cuil",
              class: "text-small text-secondary",
              mutator: (cuil) => {
                return PersonasService.formatCuil(cuil);
              },
            },
          ],
        },
        {
          class: "w-100",
          data: [{ value: "numero_legajo", class: "", label: "Legajo" }],
        },
        {
          class: "w-100",
          data: [
            {
              value: "neto",
              class: "",
              label: "Neto",
              mutator: (number) => {
                return LiquidacionesServices.numberFormat(number);
              },
            },
          ],
        },
      ],
      personas: null,
      reciboSelected: null,
      loading: false,
      guardando: false,
      validando: false,
      validacionRemotaCompleta: false,
      alertasServidor: [],
    };
  },
  computed: {
    alertasImportacion() {
      return [...revisarLiquidaciones(this.liquidaciones), ...this.alertasServidor];
    },
    erroresImportacion() {
      return this.alertasImportacion.filter(alerta => alerta.nivel === 'error');
    },
    recibosConAlertas() {
      return new Set(this.alertasImportacion.filter(alerta => alerta.numero_legajo != null).map(alerta =>
        `${alerta.numero_liquidacion}:${alerta.numero_legajo}`
      )).size;
    },
  },
  watch: {
    file: function (file) {
      this.liquidaciones = [];
      this.reciboSelected = null;
      this.alertasServidor = [];
      this.validacionRemotaCompleta = false;
      if (file) {
        this.failed = false;
        this.loading = true;
        this.leerXLS()
          .then((filas) => this.sortLiquidaciones(filas))
          .catch((error) => {
            this.failed = true;
            Swal.fire(
              "Error",
              `<p>Ocurrió un error interno</p> <p>${error}</p>`,
              "error"
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.loading = true;
    PersonasService.api.getAllForSelect()
      .then((personas) => { this.personas = personas; })
      .catch(() => {
        Swal.fire("Error", "No se pudieron cargar los legajos. Volvé a abrir esta pantalla para reintentar.", "error");
      })
      .finally(() => { this.loading = false; });
  },
  methods: {
    async leerXLS() {
      this.failed = false;
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = function () {
          let arraybuffer = this.result;
          /* convert data to binary string */
          let data = new Uint8Array(arraybuffer);
          let arr = new Array();

          for (let i = 0; i != data.length; ++i)
            arr[i] = String.fromCharCode(data[i]);
          let bstr = arr.join("");

          /* Call XLSX */
          let workbook = XLSX.read(bstr, { type: "binary" });
          /* DO SOMETHING WITH workbook HERE */
          let first_sheet_name = workbook.SheetNames[0];
          /* Get worksheet */
          let worksheet = workbook.Sheets[first_sheet_name];

          let filas = XLSX.utils.sheet_to_json(worksheet, {
            raw: true,
            blankrows: true,
            defval: "",
          });
          resolve(filas);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(this.file);
      });
    },
    async sortLiquidaciones(filas) {
      this.liquidaciones = [];
      this.reciboSelected = null;
      this.failed = false;
      this.alertasServidor = [];
      this.validacionRemotaCompleta = false;
      this.filas = filas;
      let liquidaciones = [];
      try {
        for (let fila of filas) {
          if (fila.codig) {
            let liquidacion = LiquidacionesServices.findOrNewLiquidacion(
              fila,
              liquidaciones
            );
            let recibo = LiquidacionesServices.findOrNewRecibo(
              fila,
              liquidacion.recibos,
              this.personas
            );
            let concepto = LiquidacionesServices.findOrNewConcepto(
              fila,
              recibo
            );
          }
        }
        if (!liquidaciones.length) {
          throw new Error("El archivo no contiene conceptos de liquidación para importar.");
        }
        this.liquidaciones = liquidaciones;
        await this.validarLiquidaciones();
        if (this.alertasImportacion.length) {
          Swal.fire({
            icon: this.erroresImportacion.length ? "error" : "warning",
            title: this.erroresImportacion.length ? "Hay errores que corregir" : "Hay recibos para revisar",
            text: `Se encontraron ${this.alertasImportacion.length} observaciones, ${this.erroresImportacion.length} de ellas impiden guardar. Revisá el detalle en la pantalla.`,
            confirmButtonText: "Revisar diferencias",
          });
        }
      } catch (error) {
        this.liquidaciones = [];
        this.alertasServidor = [];
        Swal.fire("Error", this.mensajeError(error), "error");
        this.failed = true;
        this.file = null;
      }
    },
    async validarLiquidaciones() {
      this.validando = true;
      this.validacionRemotaCompleta = false;
      try {
        const resultado = await LiquidacionesServices.api.validarImportacion(this.liquidaciones);
        if (!resultado.success || !Array.isArray(resultado.alertas)) {
          throw new Error("No se pudieron completar los controles de importación.");
        }
        this.alertasServidor = resultado.alertas;
        this.validacionRemotaCompleta = true;
      } finally {
        this.validando = false;
      }
    },
    async save() {
      if (this.loading || this.guardando || this.validando || !this.file || !this.liquidaciones.length) return;
      this.guardando = true;
      const liquidaciones = this.liquidaciones;
      try {
        await this.validarLiquidaciones();
        if (liquidaciones !== this.liquidaciones) return;
        if (this.erroresImportacion.length) {
          Swal.fire("No se puede guardar", "Corregí los errores indicados en los controles de importación.", "error");
          return;
        }
        if (this.alertasImportacion.length) {
          const respuesta = await Swal.fire({
            icon: "warning",
            title: "Confirmar carga con observaciones",
            text: `Hay ${this.alertasImportacion.length} observaciones en ${this.recibosConAlertas} recibo(s). ¿Revisaste las diferencias y querés guardar la liquidación?`,
            showCancelButton: true,
            confirmButtonText: "Revisé las diferencias, guardar",
            cancelButtonText: "Volver a revisar",
            focusCancel: true,
          });
          if (!respuesta.isConfirmed || liquidaciones !== this.liquidaciones) return;
        }
        this.loading = true;
        const response = await LiquidacionesServices.api.save(liquidaciones);
        if (response.success) {
          if (response.advertencia) await Swal.fire("Liquidación guardada", response.advertencia, "warning");
          this.$router.push({ name: "ListarLiquidaciones" });
        } else {
          Swal.fire("Error", String(response.mensaje), "error");
        }
      } catch (error) {
        const respuesta = error.response && error.response.data;
        if (respuesta && Array.isArray(respuesta.alertas)) this.alertasServidor = respuesta.alertas;
        Swal.fire("Error", this.mensajeError(error), "error");
      } finally {
        this.loading = false;
        this.guardando = false;
      }
    },
    mensajeError(error) {
      const respuesta = error.response && error.response.data;
      const errores = respuesta && respuesta.errors && Object.values(respuesta.errors)[0];
      return respuesta && respuesta.mensaje || errores && errores[0] || String(error.message || error);
    },
    nombreCampoAlerta(campo) {
      return {
        fecha_ingreso: "Fecha de ingreso distinta",
        sueldo_basico_legajo_sin_dato: "Básico no informado en el legajo",
        cuil: "CUIL / legajo incorrecto",
        liquidacion_duplicada: "Liquidación duplicada",
        recibo_repetido: "Recibo repetido",
        neto_diferente: "El neto no coincide",
        totales_diferentes: "Totales distintos de los conceptos",
        neto_excel_sin_dato: "Neto no informado por Holistor",
        concepto_repetido: "Concepto repetido",
        neto_no_positivo: "Neto cero o negativo",
        variacion_neto: "Variación importante del neto",
      }[campo];
    },
    valorAlerta(alerta, origen) {
      const valor = alerta[origen];
      if (valor == null) return "Sin dato";
      if (alerta.campo === "fecha_ingreso") {
        return valor.split("-").reverse().join("/");
      }
      if (["cuil", "liquidacion_duplicada", "recibo_repetido", "concepto_repetido"].includes(alerta.campo)) return String(valor);
      return new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(valor);
    },
    previewRecibo(recibo) {
      let reciboSelected = recibo;
      let liq = {
        tipo_liquidacion: this.liquidaciones[0].tipo,
        periodo: this.liquidaciones[0].periodo,
        numero: this.liquidaciones[0].numero,
      };
      reciboSelected.liquidacion = liq;
      this.reciboSelected = reciboSelected;
    },
    close() {
      this.reciboSelected = null;
    },
    recibos_liquidacion(liquidacion) {
      return liquidacion.recibos.length;
    },
    neto_liquidacion(liquidacion) {
      return LiquidacionesServices.numberFormat(liquidacion.recibos.reduce((a, b) => a + (b['neto'] || 0), 0));
    },
  },
};
</script>

<style scoped>
.alertas-importacion {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid #a36b00;
  border-radius: 4px;
  background: #fff8e6;
  color: #503600;
}
.alertas-importacion h4 { margin-top: 0; }
.errores-importacion { color: #9a2020; font-weight: bold; }
.detalle-alerta { display: block; margin-top: 0.35rem; }
.alertas-tabla { overflow-x: auto; }
.alertas-tabla table { width: 100%; border-collapse: collapse; }
.alertas-tabla caption { text-align: left; padding-bottom: 0.5rem; }
.alertas-tabla th, .alertas-tabla td {
  padding: 0.65rem;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid #d6c397;
}
</style>
